import { mdiAccountMultipleOutline, mdiMapMarkerOutline } from "@mdi/js"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"
import type { ContactOrderAppointmentRow } from "../../../../../_logic/contact-orders-contract"
type Props = {
  row: ContactOrderAppointmentRow
  disabled?: boolean
  postalEditable?: boolean
  onEditRecipients?: (row: ContactOrderAppointmentRow, event?: MouseEvent) => void
  onEditPostal?: (row: ContactOrderAppointmentRow) => void
}
export default function buildRowActions({
  row,
  disabled = false,
  postalEditable = false,
  onEditRecipients,
  onEditPostal,
}: Props): TableRowAction[] {
  const actions: TableRowAction[] = []

  if (onEditRecipients) {
    actions.push({
      id: "edit-digital-recipients",
      label: "Digitale Ansprechpartner bearbeiten",
      onClick: () => onEditRecipients(row),
      icon: mdiAccountMultipleOutline,
      disabled,
      tooltip: "Ansprechpartner und digitale Kontaktdaten bearbeiten.",
    })
  }

  if (onEditPostal) {
    actions.push({
      id: "edit-postal-recipient",
      label: "Briefempfänger bearbeiten",
      onClick: () => onEditPostal(row),
      icon: mdiMapMarkerOutline,
      disabled: disabled || !postalEditable,
      tooltip: postalEditable
        ? "Name und Anschrift des gewählten Briefempfängers bearbeiten."
        : "Zuerst einen persönlichen Briefempfänger auswählen.",
    })
  }

  return actions
}
